<template>
  <div class="account-list">
    <div class="account-list-header">
      <span>收款账户</span>
      <span class="account-list-count">({{ totalCount }}/20)</span>
      <img class="account-list-refresh" src="/static/newImg/withdraw/icon_refresh.svg" @click="loadList" />
    </div>

    <div class="account-list-items">
      

      <!-- 已绑定的账户 -->
      <div class="account-list-item account-list-item-bound" :class="{ 'account-list-item-default': isDefault(item) }" v-for="item in flatList" :key="item.id">
        <div class="account-list-item-left">
          <img class="account-list-item-img" v-if="item.category_icon" :src="item.category_icon" />
          <span class="account-list-item-icon" :class="iconClassByType(item.type)" v-else>
            {{ iconTextByType(item.type) }}
          </span>
          <div class="account-list-item-info">
            <div class="account-list-item-name">
              {{ item.category_name || item.type_name }}
              <span v-if="item.type == 2 && item.extra_info" class="account-list-item-chain-type">({{ item.extra_info }})</span>
            </div>
            <div class="account-list-item-sub">
              {{ item.mask_account }}
              <span v-if="item.extra_info && item.type != 4" class="account-list-item-chip">{{ item.extra_info }}</span>
              <span v-if="item.owner_name && item.type != 4" class="account-list-item-chip">{{ item.owner_name }}</span>
            </div>
          </div>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-default-text" v-if="isDefault(item)">默认</span>
          <span class="account-list-item-set-default" v-else @click.stop="setDefault(item)">设为默认</span>
          <img
            class="account-list-item-del"
            src="/static/newImg/withdraw/icon_delete.svg"
            @click.stop="confirmDelete(item)"
          />
        </div>
      </div>


      <!-- 未绑定总入口 -->
      <div class="account-list-item" @click="$emit('bindNo')">
        <div class="account-list-item-left">
          <img class="account-list-item-img" src="/static/newImg/bank/icon_no_wallet.png" />
          <span class="account-list-item-name account-list-item-name-unbind">您尚未绑定</span>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-action">立即绑定</span>
          <van-icon name="arrow" size="14" color="#DFB372" />
        </div>
      </div>

      <!-- 5 个添加入口 -->
      <div
        class="account-list-item"
        :class="{ disabled: hasCrypto }"
        @click="!hasCrypto && $emit('addCrypto')"
      >
        <div class="account-list-item-left">
          <img class="account-list-item-img" src="/static/newImg/bank/icon_szhb_xnb.png" />
          <span class="account-list-item-name">数字货币</span>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-action">{{ hasCrypto ? '已添加' : '添加' }}</span>
          <van-icon v-if="!hasCrypto" name="arrow" size="14" color="#DFB372" />
        </div>
      </div>

      <div class="account-list-item" @click="$emit('addThird')">
        <div class="account-list-item-left">
          <img class="account-list-item-img" src="/static/newImg/bank/icon_wallet_normal.png" />
          <span class="account-list-item-name">三方钱包</span>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-action">添加</span>
          <van-icon name="arrow" size="14" color="#DFB372" />
        </div>
      </div>

      <div class="account-list-item" @click="$emit('addBank')">
        <div class="account-list-item-left">
          <img class="account-list-item-img" src="/static/newImg/bank/icon_bank_nromal.png" />
          <span class="account-list-item-name">银行卡转账</span>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-action">添加</span>
          <van-icon name="arrow" size="14" color="#DFB372" />
        </div>
      </div>

      <div
        class="account-list-item"
        :class="{ disabled: hasAlipay }"
        @click="!hasAlipay && $emit('addAlipay')"
      >
        <div class="account-list-item-left">
          <img class="account-list-item-img" src="/static/newImg/bank/icon_normal_zfb.png" />
          <span class="account-list-item-name">支付宝</span>
        </div>
        <div class="account-list-item-right">
          <span class="account-list-item-action">{{ hasAlipay ? '已添加' : '添加' }}</span>
          <van-icon v-if="!hasAlipay" name="arrow" size="14" color="#DFB372" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountList',
  data() {
    return {
      list: [],
      totalCount: 0,
    };
  },
  computed: {
    flatList() {
      return this.list || [];
    },
    hasCrypto() {
      return (this.list || []).some((it) => parseInt(it.type) === 2);
    },
    hasAlipay() {
      return (this.list || []).some((it) => parseInt(it.type) === 5);
    },
  },
  created() {
    this.loadList();
  },
  methods: {
    refreshList() {
      this.loadList();
    },
    isDefault(item) {
      return parseInt(item.is_default) === 1;
    },
    loadList() {
      const that = this;
      this.$apiFun.post('/api/userCards/list', {}).then((res) => {
        if (res.code === 200) {
          that.list = (res.data && res.data.list) || [];
          that.totalCount = that.list.length;
          that.$emit('loaded', that.list);
          that.$emit('countChange', that.totalCount, that.list);
        }
      }).catch(() => {
        // 网络异常静默
      });
    },
    iconClassByType(type) {
      type = parseInt(type);
      if (type === 2) return 'account-list-item-icon-crypto';
      if (type === 3) return 'account-list-item-icon-third';
      if (type === 4) return 'account-list-item-icon-bank';
      if (type === 5) return 'account-list-item-icon-alipay';
      return '';
    },
    iconTextByType(type) {
      type = parseInt(type);
      if (type === 2) return '₿';
      if (type === 3) return '三';
      if (type === 4) return '银';
      if (type === 5) return '支';
      return '';
    },
    confirmDelete(item) {
      if (!item || !item.id) return;
      this.$emit('delete', item);
    },
    setDefault(item) {
      if (!item || !item.id) return;
      const that = this;
      this.$apiFun.post('/api/userCards/setDefault', { id: item.id }).then((res) => {
        if (res.code === 200) {
          that.showGlobalToast(1, '设置成功');
          that.loadList();
        } else {
          that.showGlobalToast(0, res.message || '设置失败');
        }
      }).catch((err) => {
        that.showGlobalToast(0, err.message || '设置失败');
      });
    },
    // 统一向上查找 App.vue 的 showTost
    showGlobalToast(type, msg) {
      let comp = this;
      while (comp && !comp.showTost) {
        comp = comp.$parent;
      }
      if (comp) {
        comp.showTost(type, msg);
      } else {
        // 兜底：直接用 $notify
        const str = type ? 'success' : 'danger';
        this.$notify({ type: str, message: msg, zIndex: 999999, duration: 2500 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.account-list {
  padding: 0.2rem;
}

.account-list-header {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.25rem;
  background: #222;
  border-radius: 0.12rem;
  margin-bottom: 0.2rem;
  font-size: 0.3rem;
  color: #999;

  .account-list-count {
    margin-left: 0.1rem;
  }

  .account-list-refresh {
    width: 0.45rem;
    height: 0.45rem;
    margin-left: 0.1rem;
    cursor: pointer;
  }
}

.account-list-items {
  .account-list-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem;
    background: #222;
    border-radius: 0.12rem;
    margin-bottom: 0.15rem;
    cursor: pointer;
    border: thin solid #333333;

    &.account-list-item-default {
      right: -0.1rem;
      border-color: #DFB372;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 0.5rem;
        height: 0.5rem;
        background: #DFB372;
        clip-path: polygon(100% 100%, 0 100%, 100% 0);
      }
    }
  }

  .account-list-item-left {
    display: flex;
    align-items: center;
    gap: 0.15rem;
    flex: 1;
    min-width: 0;
  }

  .account-list-item-img {
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 0.1rem;
    object-fit: contain;
    flex-shrink: 0;
    background: #1a1a1a;
    border: 1px solid #333;
  }

  .account-list-item-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
  }

  .account-list-item-sub {
    color: #999;
    font-size: 0.26rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.1rem;
  }

  .account-list-item-chip {
    padding: 0.02rem 0.12rem;
    font-size: 0.24rem;
    color: #DFB372;
    border: 1px solid #3a3426;
    border-radius: 0.3rem;
    background: rgba(209, 174, 82, 0.05);
  }

  .account-list-item-default-text {
    font-size: 0.28rem;
    color: #999;
    margin-right: 0.2rem;
  }

  .account-list-item-set-default {
    font-size: 0.28rem;
    color: #DFB372;
    margin-right: 0.2rem;
    cursor: pointer;
  }

  .account-list-item-icon {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.08rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem;
    font-weight: bold;
    color: #fff;
    flex-shrink: 0;
  }

  .account-list-item-icon-no {
    background: #1a73e8;
  }

  .account-list-item-icon-crypto {
    background: #f7931a;
  }

  .account-list-item-icon-third {
    background: #1a73e8;
  }

  .account-list-item-icon-bank {
    background: #1a73e8;
  }

  .account-list-item-icon-alipay {
    background: #1677ff;
  }

  .account-list-item-name {
    font-size: 0.32rem;
    color: #fff;
  }

  .account-list-item-chain-type {
    font-size: 0.26rem;
    color: #999;
    margin-left: 0.1rem;
  }

  .account-list-item-name-unbind {
    color: #999;
    font-size: 0.3rem;
  }

  .account-list-item-right {
    display: flex;
    align-items: center;
    gap: 0.05rem;
  }

  .account-list-item-action {
    font-size: 0.3rem;
    color: #DFB372;
  }

  .account-list-item-del {
    width: 0.42rem;
    height: 0.42rem;
    cursor: pointer;
  }

  .account-list-item.disabled {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/AccountList.vue